module.exports = __webpack_public_path__ + "static/media/works-jia.ca98a1bc.jpg";